import PropTypes from 'prop-types'
import React from 'react'
import ParagraphCitizenField from '../question_fields/ParagraphCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <ParagraphCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const ParagraphQuestion = {
  Citizen,
  name: 'ParagraphQuestion'
}

export default ParagraphQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
